import { render, staticRenderFns } from "./ProjectInstanceViewer.vue?vue&type=template&id=351c70b9&scoped=true&"
import script from "./ProjectInstanceViewer.vue?vue&type=script&lang=js&"
export * from "./ProjectInstanceViewer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInstanceViewer.vue?vue&type=style&index=0&id=351c70b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351c70b9",
  null
  
)

export default component.exports